import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewDidEnter, ViewWillEnter } from '@ionic/angular';
import { TranslatePipe } from '@ngx-translate/core';
import * as dayjs from 'dayjs';
import { MenuCategory, MenuItem } from 'src/app/models/rich-data.model';
import { CaptionPipe } from 'src/app/pipes/caption.pipe';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { FollowService } from 'src/app/services/follow.service';
@Component({
  selector: 'app-event-calendar',
  templateUrl: './event-calendar.component.html',
  styleUrls: ['./event-calendar.component.scss'],
})
export class EventCalendarComponent implements ViewDidEnter, ViewWillEnter {
  days: string[] = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
  ];
  currentDay:
    | 'monday'
    | 'tuesday'
    | 'wednesday'
    | 'thursday'
    | 'friday'
    | 'saturday'
    | 'sunday' = dayjs(new Date()).format('dddd').toLowerCase() as any;

  didInit = false;

  processing = false;
  selectedMenuCategory: MenuCategory;
  multipleMenuCategories = false;

  constructor(
    public dataServ: DataService,
    private router: Router,
    private followServ: FollowService,
    private actvRoute: ActivatedRoute,
    public authServ: AuthService,
    private titleService: Title,
    private caption: CaptionPipe
  ) {}

  ionViewWillEnter(): void {
    if (this.dataServ.menuSection && this.dataServ.menuSection.title) {
      this.titleService.setTitle(
        this.caption.transform(this.dataServ.menuSection.title, 'en')
      );
    }
  }

  async ionViewDidEnter() {
    if (this.authServ.isLogged) {
      await this.followServ.getFollows();
    }
    const SECTIONID = Number(
      this.actvRoute.snapshot.params.section || this.router.url.split('/')[2]
    );

    if (
      !this.dataServ.menuSection ||
      this.dataServ.menuSection.id !== SECTIONID
    ) {
      if (!this.dataServ.rData) {
        this.dataServ.versionControl();
      }

      this.dataServ.getSection(SECTIONID);

      if (!this.dataServ.menuSection) {
        this.router.navigateByUrl('/home');
      }
    }

    this.didInit = true;

    setTimeout(() => {
      const BUTTON = document.getElementById(this.currentDay);

      if (BUTTON) {
        BUTTON.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        });
      }
    }, 100);

    if (this.dataServ.menuSection.menu_categories.length > 1) {
      this.multipleMenuCategories = true;
    }
  }
  backToCategoryList() {
    this.selectedMenuCategory = null;
  }
  selectThisCategory(menuCategory: MenuCategory) {
    this.selectedMenuCategory = menuCategory;
  }

  async detail(detailData: MenuItem): Promise<void> {
    this.dataServ.getItem(detailData.id);
    this.router.navigate([
      'home',
      this.dataServ.menuSection.id,
      detailData.id.toString(),
    ]);
  }

  async follow(menuItem: MenuItem) {
    if (!this.authServ.profile) {
      await this.authServ.getMe();
    }

    try {
      this.processing = true;
      const ISFOLLOW = !Boolean(
        this.followServ.follows.find((x) => x.followed_id === menuItem.id)
      );

      await this.followServ.postFollow(
        menuItem,
        ISFOLLOW,
        this.authServ.profile.id
      );
    } catch {}
    this.processing = false;
  }
}
